import { writable } from "svelte/store"
/**
 * @type {FeatureState}
 */
let storedFeatureState = localStorage.getItem("P2BUpdate")

if (typeof storedFeatureState != "Object") {
  try {
    storedFeatureState = JSON.parse(storedFeatureState)
    if (!storedFeatureState) throw "storedFeatureState value is null"
  } catch (error) {
    // console.error(error)
    storedFeatureState = {}
    storedFeatureState.showUpdates = false
    storedFeatureState.notifyUser = false
    storedFeatureState.date = ""
  }
}

/**
 * @typedef {Object} FeatureState - represents application states during its operations
 * @type {Object}
 * represents application states during its operations
 *
 * @property {string} date - latest version date
 * @property {String} version - Represents the current version of the application.
 * @property {Boolean} showUpdates - whether to display updates or not.
 */
/**
 * @type {import("svelte/store").Writable<FeatureState>}
 */

const FeatureState = writable(storedFeatureState)

FeatureState.subscribe((value) => {
  localStorage.setItem("P2BUpdate", JSON.stringify(value))
})

export default FeatureState
